import { Box, IconButton, createStyles, makeStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { TextField as MaskTextField, colors } from 'design-system';

const useStyles = makeStyles(() =>
  createStyles({
    icons: {
      color: colors.bright_turquoise,
    },
    containerTextField: {
      background: colors.cloud,
      padding: '22px 16px',
    },
  }),
);

const dateMaskData = {
  date: true,
  delimiter: '/',
  datePattern: ['d', 'm', 'Y'],
};

type HeaderInputDateProps = {
  handleFromChangeInput: (value: string) => void;
  handleToChangeInput: (value: string) => void;
  fromValue: string;
  toValue: string;
};

const HeaderInputDate = ({
  handleFromChangeInput,
  handleToChangeInput,
  fromValue,
  toValue,
}: HeaderInputDateProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      className={classes.containerTextField}
      justifyContent="space-between"
    >
      <MaskTextField
        inputId="sale-web-input-fromDate"
        inputName="fromDate"
        inputLabel="Desde"
        style={{
          fontSize: '13px',
        }}
        data-testid="input-from-date"
        onChange={handleFromChangeInput}
        defaultValue={fromValue}
        maskOptions={dateMaskData}
        customDecoration={
          fromValue && (
            <IconButton
              className={classes.icons}
              data-testid="clear-input-from-date"
              onClick={() => handleFromChangeInput('')}
            >
              <CloseIcon />
            </IconButton>
          )
        }
      />
      <div style={{ marginRight: '8px', marginLeft: '8px' }} />
      <MaskTextField
        inputId="sales-web-input-toDate"
        inputName="toDate"
        inputLabel="Hasta"
        style={{
          fontSize: '13px',
        }}
        data-testid="input-to-date"
        onChange={handleToChangeInput}
        defaultValue={toValue}
        maskOptions={dateMaskData}
        customDecoration={
          toValue && (
            <IconButton
              className={classes.icons}
              data-testid="clear-input-to-date"
              onClick={() => handleToChangeInput('')}
            >
              <CloseIcon />
            </IconButton>
          )
        }
      />
    </Box>
  );
};

export default HeaderInputDate;
